<template>
  <div>
    <remplacement-edit-form
      v-if="loaded"
      :propForm="form"
      @submit="submit"
      :employes="employes"
      :type_absences="type_absences"
      :chantiers="chantiers"
      :nature_postes="nature_postes"
      :type_contrats="type_contrats"
    />
  </div>
</template>

<script>
import URL from '@/http/remplacement';
import RemplacementEditForm from '@/views/remplacement/components/RemplacementEditForm.vue';

import { mapActions } from 'vuex';

import From from 'vform';
export default {
  data() {
    return {
      form: new From({
        date_debut: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        remplacant: null,
        employe: null,
        type_absence: null,
        type_contrat: null,
        poste: null,
      }),
      loaded: false,
      employes: [],
      nature_postes: [],
      type_absences: [],
      type_contrats: [],
      chantiers: [],
    };
  },
  components: {
    RemplacementEditForm,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('remplacement', ['setCurrentRemplacement']),
    init() {
      this.id = this.$route.params.id;
      this.loaded = false;
      window.axios
        .all([
          window.axios.get(URL.REMPLACEMENT + '/' + this.id, {
            params: { edit: true },
          }),
          window.axios.get(URL.GET_REQUIREMENTS),
        ])
        .then(
          window.axios.spread((resp, resp2) => {
            let data = resp.data.remplacement;
            this.form.employe = data.employe;
            this.form.remplacant = data.remplacant;
            this.form.type_absence = data.type_absence;
            this.form.date_debut = data.date_debut;
            this.form.date_fin = data.date_fin;
            this.form.type_contrat = data.type_contrat;
            this.form.commentaire = data.commentaire;
            this.form.poste = data.poste;

            this.employes = resp2.data.employes;
            this.nature_postes = resp2.data.nature_postes;
            this.type_contrats = resp2.data.type_contrats;
            this.type_absences = resp2.data.type_absences;
            this.chantiers = resp2.data.chantiers;
            this.loaded = true;
          })
        )
        .catch();
    },
    submit(form) {
      form
        .put(URL.REMPLACEMENT + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          form.reset();
          form.clear();
          this.setCurrentRemplacement(resp.data.remplacement);
          this.init();
        })
        .catch((err) => {
          form.errors.set('message', err.response.data.message);
        })
        .finally(() => {
          this.form = form;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
